import React from 'react';
import { createIcon } from './create-icon';
import './home.scss';

export const IconHome = createIcon(<div className="icon-home" />);
